import type { ReducerAction } from 'app-redux/types/storeTypes';

import { psychicListContext } from './PsychicsContext';

import type { IPsychicsContext } from '../config/declarations';

export const psychicListReducer = (
  store: IPsychicsContext = psychicListContext,
  action: ReducerAction<keyof IPsychicsContext>,
) => {
  switch (action.type) {
    case 'psychics': {
      return { ...store, psychics: [...action.payload] };
    }
    case 'filterOptions': {
      return { ...store, filterOptions: action.payload };
    }
    default: return { ...store, psychics: action.payload };
  }
};
